import commissions from '@services/commissions'
import { alertPopup } from '@utils/popup'
import { Button, Input, Select } from 'antd'
import React from 'react'
import { missingMsg } from '../../utils'

class OneTimeCommission extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            months: 12,
            amount: null,
            comment: ''
        }
    }

    handleFormInput = e => {
        let value = e.target.value
        const field = e.target.id.split('-')[1]
        if (field === 'amount') value = value.replace(/[^0-9\.]/g, '')
        this.setState({ [field]: value })
    }

    setMonths = value => {
        this.setState({ months: value })
    }

    submit = e => {
        e.preventDefault()
        e.persist()

        const {
            info: { agentInfo, selectedClient, credit }
        } = this.props
        const { months } = this.state

        let missing = []

        let payload = {
            one_time: true,
            agent_id: agentInfo.id,
            client_id: selectedClient.client_id,
            numerator: months,
            balance: credit ? 'CREDIT' : 'DEBT'
        }

        let nodeNames = {
            // TEXTAREA: 'TEXTAREA',
            INPUT: 'INPUT'
        }

        let fields = {
            amount: 'amount',
            comment: 'comment'
        }

        for (let el in e.target.elements) {
            let target = e.target.elements[el]

            if (nodeNames[target.nodeName] && target.id.includes('input')) {
                let field = fields[target.id.split('-')[1]]
                payload[field] = target.value

                if (field) {
                    if (!target.value) {
                        missing.push(field == 'amount' ? 'סכום' : 'הערה')
                        target.style.border = 'solid red 1px'
                    } else {
                        target.style.border = 'solid #d9d9d9 1px'
                    }
                }
            }
        }

        payload.amount = Number(payload.amount)

        if (missing.length) {
            const msg = missingMsg(missing)
            alertPopup({ type: 'error', title: msg, body: '' })
            return
        }

        commissions
            .createNewCommission(payload)
            .then(res => {
                this.setState({ amount: 0, comment: '' })
                this.props.resetFormData()
                this.props.getAgentCommissions()
                this.props.getAgentCommissionTotals()
                alertPopup({ type: 'success', title: 'עמלה נוצרה בהצלחה', body: '' })
            })
            .catch(() => {
                alertPopup({ type: 'error', title: 'הפעולה נכשלה', body: '' })
            })
    }

    render() {
        const { months, amount, comment } = this.state
        const {
            info: { selectedClient }
        } = this.props

        return (
            <div>
                <form onSubmit={this.submit} style={{ ...style.column, ...style.form }}>
                    <div style={{ ...style.formLine }}>
                        <span>{`סכום עמלה כללית:`}</span>
                        <Input
                            value={amount}
                            id="input-amount"
                            onChange={this.handleFormInput}
                            style={{ ...style.inputStyle }}
                        />
                    </div>

                    <div style={{ ...style.formLine }}>
                        <span>{`פירוט:`}</span>
                        <Input
                            value={comment}
                            id="input-comment"
                            onChange={this.handleFormInput}
                            style={{ ...style.inputStyle }}
                        />
                    </div>

                    <div style={{ ...style.formLine }}>
                        <span>{'נומרטור:'}</span>
                        <Select value={months} onChange={this.setMonths} style={{ width: '70%' }}>
                            {new Array(12).fill(null).map((_, index) => {
                                return (
                                    <Select.Option
                                        key={index.toString()}
                                        style={{ paddingRight: '0' }}
                                        value={index + 1}
                                    >
                                        {index + 1}
                                    </Select.Option>
                                )
                            })}
                        </Select>
                    </div>
                    {selectedClient.client_id && (
                        <Button style={{ alignSelf: 'center' }} htmlType="submit">
                            {'אישור'}
                        </Button>
                    )}
                </form>
            </div>
        )
    }
}

const style = {
    column: { display: 'flex', flexDirection: 'column' },
    form: { width: '100%', margin: '0 0 30px 0' },
    line1: { display: 'flex', justifyContent: 'end' },
    formLine: { display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: '15px' },
    inputStyle: { width: '70%' },
    button: {
        height: '34px',
        width: '64px',
        background: 'white',
        borderRadius: '4px',
        border: 'solid #d9d9d9 1px',
        cursor: 'pointer',
        margin: '0 10px'
    }
}

export default OneTimeCommission
